import React from 'react';
import { AlertTriangle,AlertCircle, Clock, Mail, Check,Notebook } from 'lucide-react';

const QuizInstructions = ({ onStartQuiz, onClose }) => {
    const instructions = [
        {
            icon: <Clock className="instruction-icon" size={24} />,
            text: "This is a time-based test. You will have half an hour to complete the test."
        },
        {
            icon: <AlertTriangle className="instruction-icon warning" size={24} />,
            text: "You can not come back to a question after skipping it or selecting an answer."
        },
        {
            icon: <Mail className="instruction-icon" size={24} />,
            text: "You will get the report on mail after 24-48 business hours."
        },
        {
            icon: <Notebook className="instruction-icon success" size={24} />,
            text: "This test is based on the assumption that you will answer all questions truthfully."
        },
        {
            icon: <AlertCircle className="instruction-icon warning" size={24} />,
            text: "Once you start a test you can not leave it midway. The assessment link will expire once you exit the page."
        },
        {
            icon: <Check className="instruction-icon success" size={24} />,
            text: "Once you select an option you will automatically be taken to the next question."
        }
    ];

    return (
        <div className="instructions-overlay">
            <div className="instructions-card">
                <h2 className="instructions-title">Important Instructions</h2>

                <div className="instructions-list">
                    {instructions.map((instruction, index) => (
                        <div key={index} className="instruction-item">
                            <div className="instruction-icon-wrapper">
                                {instruction.icon}
                            </div>
                            <p className="instruction-text">{instruction.text}</p>
                        </div>
                    ))}
                </div>

                <div className="instructions-buttons">
                    <button
                        onClick={onClose}
                        className="btn-secondary"
                    >
                        Go Back
                    </button>
                    <button
                        onClick={onStartQuiz}
                        className="btn-primary"
                    >
                        Start Assessment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QuizInstructions;